var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#verified_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.835 7.993-1.627-1.86.227-2.46-2.407-.546L10.768 1l-2.267.973L6.235 1l-1.26 2.127-2.407.54.227 2.466-1.627 1.86 1.627 1.86-.227 2.467 2.407.547L6.235 15l2.266-.98 2.267.973 1.26-2.126 2.407-.547-.227-2.46zM13.2 8.98l-.373.433.053.567.12 1.3-1.266.287-.56.126-.294.494-.66 1.12-1.186-.514-.534-.226-.526.226-1.187.514-.66-1.114-.293-.493-.56-.127-1.267-.286.12-1.307.053-.567-.373-.433-.86-.98.86-.987.373-.433-.06-.573-.12-1.294 1.267-.286.56-.127.293-.493.66-1.12 1.187.513.533.227.527-.227 1.187-.513.66 1.12.293.493.56.127 1.267.286-.12 1.3-.054.567.374.433.86.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.227 9.167 5.68 7.613l-.987.994 2.534 2.54L12.12 6.24l-.987-.993z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "verified_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h16v16H.5z"
  })))));
};
export default SvgVerified;